import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import styles from '../AllStyle.module.scss'
const SubdivisionInfo = () => {
  const { t } = useTranslation('common')

  const [change, setChange] = useState(false)

  return (
    <div>
      <div className={styles.Design}>
        <div className={styles.DesignHeader}>
          <div className={styles.header_left}>
            <h4 className={styles.header_left_info}>{t('auto.subdivisionsinfo_subdivisionsinfo.k1')}</h4>
          </div>
          <div className={styles.headerRight}>
            <input type="text" className={styles.Design_info_change_inp} />
          </div>
        </div>

        <ul className={styles.Design_desc}>
          <li className={styles.Design_list}>
            <h3 className={styles.Design_title}>{t('auto.subdivisionsinfo_subdivisionsinfo.k2')}</h3>
            <p className={styles.Design_info}>{t('auto.subdivisionsinfo_subdivisionsinfo.k3')}</p>
          </li>

          <li className={styles.Design_list}>
            <h3 className={styles.Design_title}>{t('auto.subdivisionsinfo_subdivisionsinfo.k4')}</h3>
            <p className={styles.Design_info}>{t('auto.subdivisionsinfo_subdivisionsinfo.k3')}</p>
          </li>
          <li className={styles.Design_list}>
            <h3 className={styles.Design_title}>{t('auto.subdivisionsinfo_subdivisionsinfo.k5')}</h3>
            <p className={styles.Design_info}>{t('auto.subdivisionsinfo_subdivisionsinfo.k5')}</p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default SubdivisionInfo
